import { isNumber, isFunction } from '@motionone/utils';
import { getEasingFunction } from '@motionone/animation';
function stagger() {
  let duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.1;
  let {
    start = 0,
    from = 0,
    easing
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (i, total) => {
    const fromIndex = isNumber(from) ? from : getFromIndex(from, total);
    const distance = Math.abs(fromIndex - i);
    let delay = duration * distance;
    if (easing) {
      const maxDelay = total * duration;
      const easingFunction = getEasingFunction(easing);
      delay = easingFunction(delay / maxDelay) * maxDelay;
    }
    return start + delay;
  };
}
function getFromIndex(from, total) {
  if (from === "first") {
    return 0;
  } else {
    const lastIndex = total - 1;
    return from === "last" ? lastIndex : lastIndex / 2;
  }
}
function resolveOption(option, i, total) {
  return isFunction(option) ? option(i, total) : option;
}
export { getFromIndex, resolveOption, stagger };